import * as tslib_1 from "tslib";
import { AriaDescriber, FocusMonitor } from "@angular/cdk/a11y";
import { Directionality } from "@angular/cdk/bidi";
import { Overlay, ScrollDispatcher } from "@angular/cdk/overlay";
import { Platform } from "@angular/cdk/platform";
import { ElementRef, NgZone, OnDestroy, OnInit, ViewContainerRef, } from "@angular/core";
import { MatTooltip, MatTooltipDefaultOptions, } from "@angular/material";
import { PersonalizacionDataService, } from "src/app/core/services/personalizacion-data.service";
var AyudaPantallaDirective = /** @class */ (function (_super) {
    tslib_1.__extends(AyudaPantallaDirective, _super);
    function AyudaPantallaDirective(_overlay, _elementRef, _scrollDispatcher, _viewContainerRef, _ngZone, _platform, _ariaDescriber, _focusMonitor, _scrollStrategy, _dir, _defaultOptions, personalizacionDataService) {
        var _this = _super.call(this, _overlay, _elementRef, _scrollDispatcher, _viewContainerRef, _ngZone, _platform, _ariaDescriber, _focusMonitor, _scrollStrategy, _dir, _defaultOptions) || this;
        _this.personalizacionDataService = personalizacionDataService;
        _this.disabled = true;
        _this.suscripciones = [];
        return _this;
    }
    AyudaPantallaDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.suscripciones.push(this.personalizacionDataService.configuracion.subscribe(function (configuracion) {
            _this.disabled = !configuracion.ayudaEnPantalla;
        }));
    };
    AyudaPantallaDirective.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.suscripciones.forEach(function (suscripcion) {
            suscripcion.unsubscribe();
        });
    };
    Object.defineProperty(AyudaPantallaDirective.prototype, "tooltip", {
        get: function () {
            return this.message;
        },
        set: function (value) {
            this.message = value;
        },
        enumerable: true,
        configurable: true
    });
    return AyudaPantallaDirective;
}(MatTooltip));
export { AyudaPantallaDirective };
